/**
 * Text Blaze — text expansion / snippets
 *
 * Exposes six files to `<all_urls>` with no `use_dynamic_url`, including
 * `js/tb_remapper.js` (a `tb_`-prefixed, vendor-namespaced script), `images/icon_128.png`
 * and `css/picker.css`. All are reachable from any page at a fixed URL.
 *
 * Note: the CRX only downloads with a current `prodversion` — Text Blaze gates its
 * package on a newer Chrome, so the update server returns 204 for older versions (see
 * `tooling/lib/crx.js`).
 *
 * Manifest verified against version 3.3.14.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'idgadaccgipmpannjkmfddolnnhmeklj';

export const textBlaze: ExtensionDefinition = {
  id: ID,
  name: 'Text Blaze: Templates and Snippets',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 700_000,
  notes:
    'Six static WAR on <all_urls>, including the tb_-namespaced tb_remapper.js. ' +
    'Detection is a single fetch and conclusive.',
  signals: [
    {
      id: 'war-tb-remapper-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch js/tb_remapper.js — a vendor-namespaced (tb_) content script exposed to ' +
        'every origin. The prefix makes the path distinctive to Text Blaze.',
      weight: 1,
      run: () => probeFetch(ID, 'js/tb_remapper.js'),
    },
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load images/icon_128.png via <img> — corroborates without needing a CORS grant.',
      weight: 0.5,
      run: () => probeImage(ID, 'images/icon_128.png'),
    },
    {
      id: 'war-picker-css',
      kind: 'web-accessible-resource',
      description: 'Fetch css/picker.css — the snippet-picker stylesheet, a third path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'css/picker.css'),
    },
  ],
};
